import PropTypes from 'prop-types';

import { userGender } from 'constants/index';

export const CustomerAccountType = {
  MEMBER: 'MEMBER',
  TRUST: 'TRUST',
  AGENT: 'AGENT',
};

export const CustomerAccountTypeLabel = {
  [CustomerAccountType.MEMBER]: 'Member',
  [CustomerAccountType.TRUST]: 'Trust',
  [CustomerAccountType.AGENT]: 'Agent',
};

const customer = PropTypes.shape({
  _id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  point: PropTypes.number.isRequired,
  phone: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  avatar: PropTypes.string.isRequired,
  nation: PropTypes.string.isRequired,
  isBlocked: PropTypes.bool.isRequired,
  birthday: PropTypes.string.isRequired,
  residence: PropTypes.string.isRequired,
  totalPayment: PropTypes.number.isRequired,
  numberOfBookings: PropTypes.number.isRequired,
  gender: PropTypes.oneOf(Object.values(userGender)).isRequired,
  accountType: PropTypes.oneOf(Object.values(CustomerAccountType)).isRequired,
});

const customers = PropTypes.arrayOf(customer);

const CustomerPropTypes = {
  customer,
  customers,
};

export default CustomerPropTypes;
